module.exports = __webpack_public_path__ + "static/media/greenhouse2Step10-4.3cbddfd7.png";